"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PICKER_CHANGE_VISIBILITY_SOURCE = exports.PathToFileAccessibility = exports.IMPORTED_IMAGE_FOLDER_PATH = exports.IMPORTED_IMAGE_FOLDER_NAME = exports.CanvaFolderPath = exports.CanvaFolderName = exports.ShutterstockFolderPath = exports.ShutterstockFolderName = exports.TRY_VIDEO_PATH = exports.FILE_DETAILS_QUERY_PARAM_NAME = exports.ImageEditorLocations = exports.THUMBNAILS_FOLDER_NAME = exports.PATH_TO_VIDEO_HOSTING_INFO = exports.IMG_WIDTH_IN_DETAIL_PANEL = exports.Limits = exports.VideoProviders = exports.MAX_IMG_SIZE_FOR_THUMBNAIL = exports.UserInferredRoles = exports.PickerCanvaPopupValues = exports.ShutterstockTosValues = exports.ImportImageCopyrightNoticeValues = exports.VidyardTosStatus = exports.ROOT_FOLDER_ID = exports.ContentCategories = exports.TypeToExtensions = exports.ObjectCategory = exports.FileTypes = exports.UrlSchemes = exports.CDN_DOMAINS = exports.MessageTypes = exports.COMPLETED_REQUEST_STATUSES = exports.RequestStatus = exports.CONTENT_ACCESS_SCOPE = exports.FILE_HOSTING_PAID_DOMAINS_SCOPE = exports.FILE_MANAGER_WRITE_SCOPE = exports.FILE_MANAGER_ACCESS = exports.MARKETING_VIDEO_SCOPE = exports.CANVA_INTEGRATION_SCOPE = exports.GAMERA_MIGRATION_GATE = exports.RECALCULATE_IMAGE_DIMENSIONS_GATE = exports.BULK_IMAGE_IMPORT_GATE = exports.PICKER_PANEL_NAVIGATOR_GATE = exports.IMAGE_URL_IMPORT_GATE = exports.SUCCESS_ALERT_GATE = exports.PREVIEW_THUMBNAILS_GATE = exports.SHUTTERSTOCK_MAINTENANCE_GATE = exports.FREE_FILE_HOSTING_DOMAIN_GATE = exports.CDN_SHARDING_GATE = exports.BYPASS_ELASTIC_SEARCH_GATE = exports.CANVA_GATE = exports.BULK_FILE_VISIBILITY_GATE = exports.VIDEO_EXPERIMENTS_GATE = exports.NOTIFICATION_EVENT = exports.TRACK_EVENT = exports.MINIMUM_FETCH_FILES_LIMIT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _immutable = _interopRequireDefault(require("immutable"));

var _Immutable$Map;

var MINIMUM_FETCH_FILES_LIMIT = 40;
exports.MINIMUM_FETCH_FILES_LIMIT = MINIMUM_FETCH_FILES_LIMIT;
var TRACK_EVENT = '@@usage';
exports.TRACK_EVENT = TRACK_EVENT;
var NOTIFICATION_EVENT = 'notification';
exports.NOTIFICATION_EVENT = NOTIFICATION_EVENT;
var VIDEO_EXPERIMENTS_GATE = 'video-experiments';
exports.VIDEO_EXPERIMENTS_GATE = VIDEO_EXPERIMENTS_GATE;
var BULK_FILE_VISIBILITY_GATE = 'FileManagerUI:BulkFileVisibility';
exports.BULK_FILE_VISIBILITY_GATE = BULK_FILE_VISIBILITY_GATE;
var CANVA_GATE = 'FileManager:Canva';
exports.CANVA_GATE = CANVA_GATE;
var BYPASS_ELASTIC_SEARCH_GATE = 'FileManagerUI:BypassElasticSearch';
exports.BYPASS_ELASTIC_SEARCH_GATE = BYPASS_ELASTIC_SEARCH_GATE;
var CDN_SHARDING_GATE = 'FileManager:CdnDomainSharding';
exports.CDN_SHARDING_GATE = CDN_SHARDING_GATE;
var FREE_FILE_HOSTING_DOMAIN_GATE = 'free-file-hosting-domain';
exports.FREE_FILE_HOSTING_DOMAIN_GATE = FREE_FILE_HOSTING_DOMAIN_GATE;
var SHUTTERSTOCK_MAINTENANCE_GATE = 'FileManagerUI:ShutterstockMaintenance';
exports.SHUTTERSTOCK_MAINTENANCE_GATE = SHUTTERSTOCK_MAINTENANCE_GATE;
var PREVIEW_THUMBNAILS_GATE = 'FileManagerUI:PreviewThumbnails';
exports.PREVIEW_THUMBNAILS_GATE = PREVIEW_THUMBNAILS_GATE;
var SUCCESS_ALERT_GATE = 'FileManagerUI:AddSuccessAlertOnUpload';
exports.SUCCESS_ALERT_GATE = SUCCESS_ALERT_GATE;
var IMAGE_URL_IMPORT_GATE = 'FileManagerUI:ImageUrlImport';
exports.IMAGE_URL_IMPORT_GATE = IMAGE_URL_IMPORT_GATE;
var PICKER_PANEL_NAVIGATOR_GATE = 'FileManagerUI:PanelNavigator';
exports.PICKER_PANEL_NAVIGATOR_GATE = PICKER_PANEL_NAVIGATOR_GATE;
var BULK_IMAGE_IMPORT_GATE = 'FileManagerUI:BulkImageImport';
exports.BULK_IMAGE_IMPORT_GATE = BULK_IMAGE_IMPORT_GATE;
var RECALCULATE_IMAGE_DIMENSIONS_GATE = 'FileManagerUI:RecalculateImageDimensions';
exports.RECALCULATE_IMAGE_DIMENSIONS_GATE = RECALCULATE_IMAGE_DIMENSIONS_GATE;
var GAMERA_MIGRATION_GATE = 'FileManagerUI:GameraMigration';
exports.GAMERA_MIGRATION_GATE = GAMERA_MIGRATION_GATE;
var CANVA_INTEGRATION_SCOPE = 'canva-integration';
exports.CANVA_INTEGRATION_SCOPE = CANVA_INTEGRATION_SCOPE;
var MARKETING_VIDEO_SCOPE = 'marketing-video';
exports.MARKETING_VIDEO_SCOPE = MARKETING_VIDEO_SCOPE;
var FILE_MANAGER_ACCESS = 'file-manager-access';
exports.FILE_MANAGER_ACCESS = FILE_MANAGER_ACCESS;
var FILE_MANAGER_WRITE_SCOPE = 'file-manager-write';
exports.FILE_MANAGER_WRITE_SCOPE = FILE_MANAGER_WRITE_SCOPE;
var FILE_HOSTING_PAID_DOMAINS_SCOPE = 'file-hosting-paid-domains-access';
exports.FILE_HOSTING_PAID_DOMAINS_SCOPE = FILE_HOSTING_PAID_DOMAINS_SCOPE;
var CONTENT_ACCESS_SCOPE = 'content-access';
exports.CONTENT_ACCESS_SCOPE = CONTENT_ACCESS_SCOPE;
var RequestStatus = (0, _keyMirror.default)({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null,
  NOTFOUND: null
});
exports.RequestStatus = RequestStatus;
var COMPLETED_REQUEST_STATUSES = [RequestStatus.SUCCEEDED, RequestStatus.FAILED, RequestStatus.NOTFOUND];
exports.COMPLETED_REQUEST_STATUSES = COMPLETED_REQUEST_STATUSES;
var MessageTypes = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
exports.MessageTypes = MessageTypes;

var CDN_DOMAINS = _immutable.default.Map({
  qa: 'cdn2.hubspotqa.net',
  prod: 'cdn2.hubspot.net'
});

exports.CDN_DOMAINS = CDN_DOMAINS;
var UrlSchemes = (0, _keyMirror.default)({
  SIMPLIFIED: null,
  LEGACY: null
});
exports.UrlSchemes = UrlSchemes;
var FileTypes = (0, _keyMirror.default)({
  IMG: null,
  MOVIE: null,
  DOCUMENT: null,
  AUDIO: null,
  OTHER: null
});
exports.FileTypes = FileTypes;
var ObjectCategory = (0, _keyMirror.default)({
  FILE: null,
  FOLDER: null
});
exports.ObjectCategory = ObjectCategory;

var TypeToExtensions = _immutable.default.Map((_Immutable$Map = {}, (0, _defineProperty2.default)(_Immutable$Map, FileTypes.IMG, new _immutable.default.Set(['jpg', 'jpeg', 'png', 'gif', 'tif', 'tiff', 'ico', 'bmp', 'webp', 'svg'])), (0, _defineProperty2.default)(_Immutable$Map, FileTypes.MOVIE, new _immutable.default.Set(['mov', 'avi', 'flv', 'wmv', 'rm', '3gp', '3g2', 'asf', 'asx', 'mpg', 'mp4', 'mpeg', 'swf', 'm4v', 'webm'])), (0, _defineProperty2.default)(_Immutable$Map, FileTypes.DOCUMENT, new _immutable.default.Set(['csv', 'doc', 'docx', 'dot', 'dotx', 'key', 'pdf', 'pot', 'potx', 'pps', 'ppsx', 'ppt', 'pptx', 'txt', 'wpd', 'wps', 'wri', 'xls', 'xlsb', 'xlsx', 'xlt', 'xlx', 'xml'])), (0, _defineProperty2.default)(_Immutable$Map, FileTypes.AUDIO, new _immutable.default.Set(['aif', 'm4a', 'mp3', 'mpa', 'ra', 'wav', 'wma'])), _Immutable$Map));

exports.TypeToExtensions = TypeToExtensions;

var ContentCategories = _immutable.default.Map({
  UNMAPPED: 0,
  LANDING_PAGE: 1,
  EMAIL: 2,
  BLOG_POST: 3,
  SITE_PAGE: 4,
  LEGACY_PAGE: 5,
  KNOWLEDGE_ARTICLE: 6
});

exports.ContentCategories = ContentCategories;
var ROOT_FOLDER_ID = 'root';
exports.ROOT_FOLDER_ID = ROOT_FOLDER_ID;
var VidyardTosStatus = (0, _keyMirror.default)({
  ACCEPTED: null,
  HIDDEN: null,
  NOT_ASKED: null,
  DISABLED: null,
  UNSYNCED: null
});
exports.VidyardTosStatus = VidyardTosStatus;
var ImportImageCopyrightNoticeValues = {
  ACCEPTED: 'ACCEPTED'
};
exports.ImportImageCopyrightNoticeValues = ImportImageCopyrightNoticeValues;
var ShutterstockTosValues = {
  ACCEPTED: 'ACCEPTED'
};
exports.ShutterstockTosValues = ShutterstockTosValues;
var PickerCanvaPopupValues = {
  DISMISSED: 'DISMISSED'
};
exports.PickerCanvaPopupValues = PickerCanvaPopupValues;

var UserInferredRoles = _immutable.default.Map({
  HEAVY_MARKETER: 'heavyMarketers',
  CRM_AND_SALES: 'crmAndSales',
  CRM: 'crmUsers'
});

exports.UserInferredRoles = UserInferredRoles;
var MAX_IMG_SIZE_FOR_THUMBNAIL = 999999;
exports.MAX_IMG_SIZE_FOR_THUMBNAIL = MAX_IMG_SIZE_FOR_THUMBNAIL;
var VideoProviders = (0, _keyMirror.default)({
  VIDYARD: null
});
exports.VideoProviders = VideoProviders;
var Limits = (0, _keyMirror.default)({
  EMBEDDABLE_VIDEO: null
});
exports.Limits = Limits;
var IMG_WIDTH_IN_DETAIL_PANEL = 430;
exports.IMG_WIDTH_IN_DETAIL_PANEL = IMG_WIDTH_IN_DETAIL_PANEL;
var PATH_TO_VIDEO_HOSTING_INFO = ['meta', 'video_data', 'hosting_infos'];
exports.PATH_TO_VIDEO_HOSTING_INFO = PATH_TO_VIDEO_HOSTING_INFO;
var THUMBNAILS_FOLDER_NAME = 'custom-video-thumbnails';
exports.THUMBNAILS_FOLDER_NAME = THUMBNAILS_FOLDER_NAME;
var ImageEditorLocations = (0, _keyMirror.default)({
  SOCIAL_PREVIEW: null,
  DRAWER: null,
  EDITOR_MODAL: null
});
exports.ImageEditorLocations = ImageEditorLocations;
var FILE_DETAILS_QUERY_PARAM_NAME = 'showDetails';
exports.FILE_DETAILS_QUERY_PARAM_NAME = FILE_DETAILS_QUERY_PARAM_NAME;
var TRY_VIDEO_PATH = 'tryVideo';
exports.TRY_VIDEO_PATH = TRY_VIDEO_PATH;
var ShutterstockFolderName = 'Stock images';
exports.ShutterstockFolderName = ShutterstockFolderName;
var ShutterstockFolderPath = "/" + ShutterstockFolderName;
exports.ShutterstockFolderPath = ShutterstockFolderPath;
var CanvaFolderName = 'Canva images';
exports.CanvaFolderName = CanvaFolderName;
var CanvaFolderPath = "/" + CanvaFolderName;
exports.CanvaFolderPath = CanvaFolderPath;
var IMPORTED_IMAGE_FOLDER_NAME = 'Imported images';
exports.IMPORTED_IMAGE_FOLDER_NAME = IMPORTED_IMAGE_FOLDER_NAME;
var IMPORTED_IMAGE_FOLDER_PATH = "/" + IMPORTED_IMAGE_FOLDER_NAME;
exports.IMPORTED_IMAGE_FOLDER_PATH = IMPORTED_IMAGE_FOLDER_PATH;
var PathToFileAccessibility = ['meta', 'allows_anonymous_access'];
exports.PathToFileAccessibility = PathToFileAccessibility;
var PICKER_CHANGE_VISIBILITY_SOURCE = 'picker-change-visibility';
exports.PICKER_CHANGE_VISIBILITY_SOURCE = PICKER_CHANGE_VISIBILITY_SOURCE;